import { render, staticRenderFns } from "./SingleImgRestrict.vue?vue&type=template&id=1ed6363e&"
import script from "./SingleImgRestrict.vue?vue&type=script&lang=js&"
export * from "./SingleImgRestrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports